// TODO: Remove no-shadow eslint disable after fixed: https://github.com/typescript-eslint/typescript-eslint/issues/2484
// eslint-disable-next-line no-shadow
export enum LanguageMutationTypes {
    SET_LANG = 'SET_LANG',
  }
  